import VueCookies from 'vue-cookies'
import { LocationService } from "@/services/nextshop/location.service";

export default {
  methods: {
    async getListLocation(roleUser) {
      try {
        const params = {
          limit: 1000,
          page: 1,
          sortBy: "name",
          sort: "ASC",
          merchantId: VueCookies.get('MID'),
        }
        const dataLocation = await LocationService.getListLocation(params);
        if (dataLocation.success && roleUser === "employee") {
          return dataLocation.data.filter(e => e.coLocationId === VueCookies.get('LID'))
        } else {
          return dataLocation.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  }
}